import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  let data = isSuccessResponse(response)
  return data?.response?.cards ?? []
}

export const cardsListParser = (cards: any) => {
  // type: types.optional(types.array(CardType), [cardTypeDropdownData]), // Debit, Credit, Prepaid
  // isSelected: types.optional(types.boolean, false), // All selected
  // subTypes: types.optional(types.array(CardSubType), CardSubTypes),
  // schemes: types.optional(types.array(CardScheme), []), //VISA, Master, Rupay
}

const getCardsList = (cardType: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getCardList),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      cardType: cardType,
    },
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { getCardsList }
